import { useEffect } from "react";
import {
  PushNotificationEventListeners,
  registerPushNotifications,
  addPushNotificationsListeners,
} from "hub/src/utils/firebase/pushNotification";
import { useDataRef } from "./useDataRef";

export type UsePushNotificationsConfig = {
  disabled?: boolean;
  listeners: Partial<PushNotificationEventListeners>;
};

export const usePushNotifications = (config: UsePushNotificationsConfig) => {
  const { disabled, listeners } = config;

  const listenersRef = useDataRef(listeners);

  useEffect(() => {
    if (disabled) {
      return;
    }

    const setupPushNotifications = async () => {
      try {
        await registerPushNotifications();
        await addPushNotificationsListeners({
          registration: (...params) =>
            listenersRef?.current?.registration?.(...params),
          registrationError: (...params) =>
            listenersRef?.current?.registrationError?.(...params),
          pushNotificationReceived: (...params) =>
            listenersRef?.current?.pushNotificationReceived?.(...params),
          pushNotificationActionPerformed: (...params) =>
            listenersRef?.current?.pushNotificationActionPerformed?.(...params),
        });
      } catch (error) {
        console.error("Push Notifications Setup error:", error);
      }
    };

    setupPushNotifications();
  }, [disabled]);
};
